export const AppConstant = {
  clientId: '1',
  clientSecret: '',
  domain: 'https://g41mjebaw2.execute-api.us-east-1.amazonaws.com/v1_0',
  auth0: {
    domain: 'orthoteks.auth0.com',
    clientID: '1elTcQF9qoaYGdj7t3V6ePjMr3FCJLtZ',
    redirectUri: 'http://localhost:4200/callback',
    connection: 'FitsCanada'
  },
  format: {
    fullDate: 'MM/dd/yyyy HH:mm',
    moment: {
      sortDate: 'YYYY-MM-DD'
    }
  },
  idleTimeout: 1800 // seconds
};
